import { render, staticRenderFns } from "./Contribution.vue?vue&type=template&id=015dbda1&scoped=true"
import script from "./Contribution.vue?vue&type=script&lang=js"
export * from "./Contribution.vue?vue&type=script&lang=js"
import style0 from "./Contribution.vue?vue&type=style&index=0&id=015dbda1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015dbda1",
  null
  
)

export default component.exports